import { abbreviateAddress } from 'utils/formatting'
import { KeyValuePair } from './TokenDetails'
import { format, formatDistanceToNow, fromUnixTime } from 'date-fns'
import { useTokenGenesis } from 'hooks/useTokenGenesis'
import AddressDisplay from '@components/shared/AddressDisplay'
import { ExternalLink } from '@components/shared/ExternalLink'
import { usePreferredExplorerUrl } from 'hooks/usePreferredExplorerUrl'
import OpenExplorerLinkIcon from '@components/shared/OpenExplorerLinkIcon'
import { useTranslation } from 'next-i18next'
import { useDateFnsLocale } from 'hooks/useDateFnsLocale'

const TokenGenesis = () => {
  const { t } = useTranslation('token-page')
  const makeExplorerUrlForCreationOwner = usePreferredExplorerUrl('address')
  const { creationData } = useTokenGenesis()
  const dateFnsLocale = useDateFnsLocale()

  return (
    <div className="w-full space-y-3">
      <KeyValuePair
        title={t('genesis.creation-date')}
        value={
          <div className="flex flex-col items-end">
            <p className="mb-0.5 text-th-fgd-1">
              {creationData?.blockUnixTime
                ? format(
                    fromUnixTime(creationData.blockUnixTime),
                    dateFnsLocale.formatLong.date({ width: 'medium' }),
                    { locale: dateFnsLocale },
                  )
                : '–'}
            </p>
            <span className="text-xs leading-none text-th-fgd-4">
              {creationData?.blockUnixTime
                ? t('genesis.ago', {
                    timeDistance: formatDistanceToNow(
                      fromUnixTime(creationData.blockUnixTime),
                      { locale: dateFnsLocale },
                    ),
                  })
                : '–'}
            </span>
          </div>
        }
      />
      <KeyValuePair
        title={t('genesis.creator-address')}
        value={
          creationData?.owner ? (
            <AddressDisplay className="flex items-center">
              <span className="mr-1.5 text-xs">
                {abbreviateAddress(creationData.owner)}
              </span>
              <ExternalLink
                className="text-th-fgd-3"
                href={makeExplorerUrlForCreationOwner(creationData.owner)}
              >
                <OpenExplorerLinkIcon className="size-4" />
              </ExternalLink>
            </AddressDisplay>
          ) : (
            <div className="h-[22px]">–</div>
          )
        }
      />
      {/* <KeyValuePair
        title="Creator balance"
        value={creatorBalance ? formatNumericValue(creatorBalance) : '0'}
        isNumber
      /> */}
    </div>
  )
}

export default TokenGenesis
